/** Проверка качества графика по 14 пунктам DCMA (ПЛ-12) — считается на сервере тем же ядром */
import type { DcmaReport, ScheduleView } from '@epc/contracts';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../../lib/api';
import { Badge, ErrorBox, Spinner } from '../../ui/feedback';
import { Panel } from '../../ui/layout';

export function CheckPanel({ view }: { view: ScheduleView }) {
  const q = useQuery({
    queryKey: ['schedule-check', view.schedule.id, view.schedule.revision, view.baselines.length],
    queryFn: () => api<DcmaReport>(`/schedules/${view.schedule.id}/check`),
  });
  const [open, setOpen] = useState<number | null>(null);
  if (q.isPending) return <Spinner label="Проверка графика" />;
  if (q.isError) return <ErrorBox error={q.error} />;
  const byId = new Map(view.activities.map((a) => [a.id, a]));
  const fmt = (v: number | null, unit: string) =>
    v === null
      ? '—'
      : unit === 'pct'
        ? `${String(v).replace('.', ',')}%`
        : unit === 'index'
          ? String(v).replace('.', ',')
          : String(v);
  return (
    <Panel
      title="Проверка по 14 пунктам DCMA"
      meta={`выполнено ${q.data.passed} из ${q.data.total}`}
      bodyClassName="p-0"
    >
      <ol className="divide-y divide-line">
        {q.data.items.map((it) => (
          <li key={it.code}>
            <button
              type="button"
              className="grid min-h-[52px] w-full grid-cols-[32px_1fr_auto] items-center gap-3 px-5 py-2.5 text-left"
              onClick={() => setOpen(open === it.no ? null : it.no)}
              aria-expanded={open === it.no}
              disabled={!it.activityIds.length}
            >
              <span className="num text-ink-2">{it.no}</span>
              <span className="min-w-0">
                <span className="block text-[14px] text-ink">{it.title}</span>
                <span className="block text-[12px] text-ink-2">
                  Норма {it.threshold}. {it.hint}
                </span>
              </span>
              <span className="flex items-center gap-2">
                <span className="num text-[14px]">{fmt(it.value, it.unit)}</span>
                {it.pass === null ? (
                  <Badge>нет данных</Badge>
                ) : it.pass ? (
                  <Badge tone="success">норма</Badge>
                ) : (
                  <Badge tone="danger">не норма</Badge>
                )}
              </span>
            </button>
            {open === it.no ? (
              <ul className="flex flex-col gap-0.5 bg-surface-2 px-5 py-2.5 pl-[68px] text-[13px]">
                {it.activityIds.slice(0, 100).map((id) => (
                  <li key={id}>
                    {byId.get(id)?.code} {byId.get(id)?.name}
                  </li>
                ))}
                {it.activityIds.length > 100 ? <li>и ещё {it.activityIds.length - 100}</li> : null}
              </ul>
            ) : null}
          </li>
        ))}
      </ol>
    </Panel>
  );
}
